import ServiceThreeAbout from "components/abouts/service-3-about";
import AgencyCta from "components/cta/agency-cta";
import SEO from "components/seo";
import ServiceThreeVideoArea from "components/video-area/service-3-video-area";
import ElementsCarouselMain from "elements/elements-carousel";
import CarouselWithControls from "elements/elements-carousel/carousel-with-controls";
import PortfolioSliderGalleryEl from "elements/elements-carousel/portfolio-slider-gallery-el";
import FooterSeven from "layout/footers/footer-7";
import HeaderSix from "layout/headers/header-6";
import Wrapper from "layout/wrapper";
import React from "react";

// Banner Image

import bannericonnft from "assets/img/Main Images/NFT/rionickicon.png"
import bannernft from "assets/img/Main Images/NFT/video-bg-2.jpg"

// NFT Service Images

import NFTService1 from "assets/img/Main Images/NFT/Non fungible token development services.jpg"
import NFTService2 from "assets/img/Main Images/NFT/Non fungible token development services 2.jpg"

const NFT = () => {
  return (
    <Wrapper>
      <SEO
        metaTitle={"NFT Development Services | 2D & 3D NFT Art"}
        metaDesc={
          "We provide 2d and 3d nft art services that are unique, eye-catching and customized."
        }
        metaKeywords={
          "nft art services, nft development services, digital art, nft price, nft development in delhi ncr, nft developer, nft development, nft development cost"
        }
        canonical="https://www.rionick.com/viral-cgi-videos"
        pageTitle={"Nft"}
      />
      <HeaderSix top_bar={false} commonOffCanvas={true} />
      <ServiceThreeVideoArea
        banner_icon= {bannericonnft}
        video_bg={bannernft}
        t1="We are here for you."
        t2="We deliver exceptional CGI video solutions for product promotion, architectural visualization, and storytelling across films, games, and more."
      />
      {/* <ServiceThreeFeature/> */}
      {/* <ServiceThreeServices /> */}
      <ServiceThreeAbout
        list={[
          "Product Advertising",
          "Architecture & Real Estate",
          "Film & Entertainment",
          "Education & Training",
          "Gaming & Simulation",
          "E-commerce & Retail",
        ]}
        t1="What industries benefit from CGI video services?"
        p="CGI (Computer-Generated Imagery) videos effectively serve the visual and marketing needs of the following industries:"
        reverse={true}
        about_img={NFTService1}

      />
      <ServiceThreeAbout
        t1="Why choose us for CGI Video Services?"
        p="At Rionick Studios, we specialize in crafting high-quality CGI videos that captivate, engage, and convert. Our team of skilled 3D artists, animators, and visual storytellers work collaboratively to produce hyper-realistic, custom-made CGI content for businesses across industries. Whether it's an architectural walkthrough, a cinematic product launch, or a stunning entertainment clip, we ensure your vision comes to life with precision and creativity. With a strong focus on detail, motion, and emotion—we turn your ideas into compelling visual stories."
        reverse={false}
        about_img={NFTService2}

      />
      <PortfolioSliderGalleryEl />
      <AgencyCta
        bclr="tp-btnr bg-danger"
        title="Every Product Story Deserves Stunning CGI Visuals"
        btext="Get in Touch"
        content="Discuss your project with our specialist"
        element_style={true}
      />

      <FooterSeven />
    </Wrapper>
  );
};

export default NFT;
